import React, { Component } from "react";
import { Row } from "react-bootstrap";
import moment from "moment";

import { Polyline, Marker } from "react-google-maps";

import { translate, getLanguage } from "../../Translation/Translation";

const { compose, lifecycle, withStateHandlers } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap } = require("react-google-maps");

const MapWithADirectionsRenderer = compose(
  withScriptjs,
  withGoogleMap,
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
    }
  ),
  lifecycle({
    componentDidMount() {
      const google = window.google;
      let WAYPOINTS = [];
      let bounds = new google.maps.LatLngBounds();

      WAYPOINTS.push({
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lon),
      });
      WAYPOINTS.push({
        lat: parseFloat(this.props.destlat),
        lng: parseFloat(this.props.destlon),
      });

      let MARKERS = [];

      MARKERS.push(
        <Marker
          key={WAYPOINTS[0].lat}
          position={{ lat: WAYPOINTS[0].lat, lng: WAYPOINTS[0].lng }}
          icon="/images/POI_marker_start.png"
        ></Marker>
      );
      MARKERS.push(
        <Marker
          key={WAYPOINTS[1].lat}
          position={{ lat: WAYPOINTS[1].lat, lng: WAYPOINTS[1].lng }}
          icon="/images/POI_marker_end.png"
        ></Marker>
      );

      for (var i = 0; i < WAYPOINTS.length; i++) {
        bounds.extend(WAYPOINTS[i]);
      }

      var WORLD_DIM = { height: 256, width: 256 };
      var ZOOM_MAX = 21;

      var mapDim = { width: 630, height: 300 };

      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();

      var sin = Math.sin((ne.lat() * Math.PI) / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      var latRad1 = Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;

      sin = Math.sin((sw.lat() * Math.PI) / 180);
      radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      var latRad2 = Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;

      var latFraction = (latRad1 - latRad2) / Math.PI;

      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

      var latZoom = Math.floor(
        Math.log(mapDim.height / WORLD_DIM.height / latFraction) / Math.LN2
      );
      var lngZoom = Math.floor(
        Math.log(mapDim.width / WORLD_DIM.width / lngFraction) / Math.LN2
      );
      var zoom = Math.min(latZoom, lngZoom, ZOOM_MAX);

      if (WAYPOINTS.length === 2) {
        zoom = zoom - 2;
      }

      this.setState({
        directions: WAYPOINTS,
        center: bounds.getCenter(),
        zoom: zoom,
        markers: MARKERS,
      });
    },
  })
)((props) => (
  <GoogleMap
    defaultZoom={6}
    zoom={props.zoom}
    center={props.center}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            { saturation: 36 },
            { color: "#333333" },
            { lightness: 40 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" },
          ],
        },
      ],
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    }}
  >
    {props.directions && (
      <Polyline
        options={{
          geodesic: true,
          strokeColor: "rgb(41,63,84)",
          strokeOpacity: 1.0,
          strokeWeight: 3,
        }}
        path={props.directions}
      />
    )}
    {props.markers}
  </GoogleMap>
));

class ItinerariesSidebar extends Component {
  render() {
    return (
      <div>
        {this.props.outgoingTrip && (
          <div>
            <div
              className="ItenerarySidebarItem"
              style={{ textAlign: "center" }}
            >
              <div className="stepLabel" style={{ margin: "0px" }}>
                {translate(getLanguage(), "Departure")}
              </div>
              <Row style={{ margin: "0px" }}>
                <div>
                  <div className="portName">
                    {this.props.outgoingTrip.departureLocation.name}
                  </div>
                  <div className="portArrow">
                    <svg
                      viewBox="0 0 1000 1000"
                      className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                    >
                      <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"></path>
                    </svg>
                  </div>
                  <div className="portName">
                    {this.props.outgoingTrip.arrivalLocation.name}
                  </div>
                </div>
              </Row>
              <hr style={{ margin: "10px" }}></hr>

              <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                <div
                  className="vesselImage"
                  style={{
                    backgroundImage: `url(${this.props.outgoingTrip.company.imageUrl})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "40px",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <div className="vesselName">
                  {this.props.outgoingTrip.vessel.name}
                </div>
              </div>
              <hr style={{ margin: "10px" }}></hr>

              <div className="sidebarLabelBottom">
                {translate(getLanguage(), "Departure Time")}
              </div>
              <div className="veselDepartureDay">
                {moment(
                  this.props.outgoingTrip.departureDateTime,
                  "YYYY-MM-DD HH:mm:SS"
                ).format("dddd DD MMMM YYYY, HH:mm")}
              </div>
              <div className="sidebarLabelBottom">
                {translate(getLanguage(), "Arrival Time")}
              </div>
              <div className="veselDepartureDay">
                {moment(
                  this.props.outgoingTrip.arrivalDateTime,
                  "YYYY-MM-DD HH:mm:SS"
                ).format("dddd DD MMMM YYYY, HH:mm")}
              </div>

              {this.props.incomingTrip && this.props.shouldDisplayReturn && (
                <div>
                  <div className="stepLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Return")}
                  </div>
                  <Row style={{ margin: "0px" }}>
                    <div>
                      <div className="portName">
                        {this.props.incomingTrip.departureLocation.name}
                      </div>
                      <div className="portArrow">
                        <svg
                          viewBox="0 0 1000 1000"
                          className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                        >
                          <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"></path>
                        </svg>
                      </div>
                      <div className="portName">
                        {this.props.incomingTrip.arrivalLocation.name}
                      </div>
                    </div>
                  </Row>
                  <hr style={{ margin: "10px" }}></hr>

                  <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                    <div
                      className="vesselImage"
                      style={{
                        backgroundImage: `url(${this.props.incomingTrip.company.imageUrl})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        width: "100%",
                        height: "40px",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                    <div className="vesselName">
                      {this.props.incomingTrip.vessel.name}
                    </div>
                  </div>
                  <div className="sidebarLabelBottom">
                    {translate(getLanguage(), "Departure Time")}
                  </div>
                  <div className="veselDepartureDay">
                    {moment(
                      this.props.incomingTrip.departureDateTime,
                      "YYYY-MM-DD HH:mm:SS"
                    ).format("dddd DD MMMM YYYY, HH:mm")}
                  </div>
                  <div className="sidebarLabelBottom">
                    {translate(getLanguage(), "Arrival Time")}
                  </div>
                  <div className="veselDepartureDay">
                    {moment(
                      this.props.incomingTrip.arrivalDateTime,
                      "YYYY-MM-DD HH:mm:SS"
                    ).format("dddd DD MMMM YYYY, HH:mm")}
                  </div>
                </div>
              )}

              <Row style={{ margin: "0px" }}>
                <MapWithADirectionsRenderer
                  lat={`${this.props.outgoingTrip &&
                    this.props.outgoingTrip.departureLocation.latitude}`}
                  lon={`${this.props.outgoingTrip &&
                    this.props.outgoingTrip.departureLocation.longitude}`}
                  destlat={`${this.props.outgoingTrip &&
                    this.props.outgoingTrip.arrivalLocation.latitude}`}
                  destlon={`${this.props.outgoingTrip &&
                    this.props.outgoingTrip.arrivalLocation.longitude}`}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `300px` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={
                    <div
                      style={{
                        height: "300px",
                        marginBottom: "10px",
                        boxShadow: "0px 0px 7px #888888",
                      }}
                    />
                  }
                />
              </Row>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ItinerariesSidebar;



// WEBPACK FOOTER //
// ./src/components/Pages/Itineraries/ItinerariesSidebar.js